
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparisons/frame-io-vs-filestage",
      function () {
        return require("private-next-pages/comparisons/frame-io-vs-filestage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparisons/frame-io-vs-filestage"])
      });
    }
  